import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './MhcBrandTheme.css';
import './workspace/Workspace.css';

ReactDOM.render(<App />, document.getElementById('root'));
